export default "__VITE_ASSET__f4897eab__"